module.exports = __webpack_public_path__ + "img/dd1.2cdf299a.jpg";